/**
 * A collection of type-safe functional programming helpers - implement type-safe
 * helpers here instead of importing utility dependencies like lodash
 */

import memoizeOne from 'memoize-one'

/**
 * This generic higher-order function applies a selector to a list of items,
 * ultimately returning a list of the unique values returned by the selector.
 * In the future we might want to accept an optional comparator function
 * to have a more flexible 'equality check'
 */
export const makeGetUniqueValues = <TItem, TValue>(getValue: (item: TItem) => TValue) =>
  memoizeOne((items: Array<TItem>) =>
    items.reduce<Array<TValue>>((acc, item) => {
      const value = getValue(item)
      if (!acc.includes(value)) acc.push(value)
      return acc
    }, [])
  )
